import { render, staticRenderFns } from "./CustomizeFormInfo.vue?vue&type=template&id=a8a594b2&scoped=true"
import script from "./CustomizeFormInfo.vue?vue&type=script&lang=js"
export * from "./CustomizeFormInfo.vue?vue&type=script&lang=js"
import style0 from "./CustomizeFormInfo.vue?vue&type=style&index=0&id=a8a594b2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8a594b2",
  null
  
)

export default component.exports